"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOSDeviceConnectorV2 = void 0;
const deviceConnector_1 = require("../../../mobileCommunicator/deviceConnector/deviceConnector");
// @constants
const platform_1 = require("../../../platform");
class IOSDeviceConnectorV2 extends deviceConnector_1.DeviceConnector {
    constructor(_config) {
        super();
        this._config = _config;
        this.webViewPlatform = platform_1.Platform.IOS;
        this.areToolsLoaded = () => true;
        this.call = (type, payload) => {
            if (!this._config.scheme) {
                throw new Error('Scheme is not defined');
            }
            fetch(`${this._config.scheme}://${type}`, {
                body: JSON.stringify(payload),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                method: 'POST',
            })
                .then(response => response.json())
                .then(data => {
                //Temporal solution. We need to return a string to maintain the same structure as V1 version and android version.
                window.nativeResponse(type, data);
            });
        };
    }
}
exports.IOSDeviceConnectorV2 = IOSDeviceConnectorV2;
//# sourceMappingURL=deviceConnectorIosV2.js.map